/**
 * Replace a units list while reusing previous unit object references when content is unchanged.
 * Avoids remounting open cards solely because the array / tree identity changed.
 */

export function replaceUnitsPreservingUnchangedRefs<T extends { e251_UnitId?: string }>(
    prevUnits: T[],
    incomingUnits: T[]
): T[] {
    if (!prevUnits?.length) {
        return incomingUnits;
    }

    const prevById = new Map(
        prevUnits.filter(u => u.e251_UnitId).map(u => [u.e251_UnitId as string, u])
    );

    let anyChange = prevUnits.length !== incomingUnits.length;
    const next = incomingUnits.map(incoming => {
        const id = incoming.e251_UnitId;
        const prev = id ? prevById.get(id) : undefined;
        if (!prev) {
            anyChange = true;
            return incoming;
        }
        if (JSON.stringify(prev) === JSON.stringify(incoming)) {
            return prev;
        }
        anyChange = true;
        return incoming;
    });

    if (!anyChange && next.every((u, i) => u === prevUnits[i])) {
        return prevUnits;
    }
    return next;
}
